import React, { createContext, useContext } from "react";

const OverviewStateContext = createContext<'dreamhome'|'prize' |undefined>(undefined);

interface OverviewProviderProps {
  prizeType: "dreamhome" | "prize";
  children: React.ReactNode;
}
const OverviewProvider = (props:OverviewProviderProps) => {
  return (
    <OverviewStateContext.Provider value={props.prizeType}>
      {props.children}
    </OverviewStateContext.Provider>
  );
};

const useOverviewContext = ()=>{
    const context = useContext(OverviewStateContext)
    if (context === undefined) {
        throw new Error('useOverviewContext must be used within a OverviewProvider')
    }
    return context
}

export {useOverviewContext,OverviewProvider}